<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-input v-model="searchName" placeholder="请输入线下课名称" />
      </el-col>
      <el-col :span="3">
        <el-button type="primary" @click="getOfflineCourseList">搜索</el-button>
      </el-col>
    </el-row>

    <el-table
      ref="multipleTable"
      :data="tableData"
      row-key="courseId"
      style="width: 100%"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55"
      ></el-table-column>
      <el-table-column prop="courseName" label="线下课名称"> </el-table-column>
      <el-table-column prop="teacherName" label="讲师名称"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import * as api from '@/api/courseStructure/courseStructure'
export default {
  props: ['userType', 'mhmId', 'zyVideoSectionId'],
  data() {
    return {
      searchName: '',
      tableData: [],
      pageObj: {
        page: 1,
        pageSize: 1000,
      },
      total: 0,
    }
  },
  created() {
    this.getOfflineCourseList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  methods: {
    getOfflineCourseList() {
      const { page, pageSize } = this.pageObj
      api
        .getTeacherCourseList({
          mhmId: this.mhmId,
          userType: this.userType,
          uid: this.getUId,
          page,
          pageSize,
          zyVideoSectionId: this.zyVideoSectionId,
          name: this.searchName,
        })
        .then(({ data }) => {
          if (data.code == 100000) {
            this.tableData = data.data
            const index = this.tableData.findIndex(
              (item) => item.checked === '1'
            )
            if (index > -1) {
              this.$refs.multipleTable.toggleRowSelection(
                this.tableData[index],
                true
              )
            }
          } else {
            this.$message({ type: 'error', message: data.msg })
          }
        })
    },
    save() {
      const selectedList = this.$refs.multipleTable.selection
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      } else if (selectedList.length > 1) {
        return this.$message({ type: 'warning', message: '最多可选一门课' })
      } else {
        this.$parent.$parent.submitForm(selectedList[0].courseId)
      }
    },
  },
}
</script>

<style>
</style>